// FNV-1a 32-bit hash rendered as base36. Deterministic and dependency-free —
// used to derive short, stable identifiers from string content (e.g. a quote
// PDF filename). Not for security; collision-resistance is not a goal.
export const hashToBase36 = (input) => {
    let hash = 0x811c9dc5;
    for (let i = 0; i < input.length; i += 1) {
        hash ^= input.charCodeAt(i);
        // FNV prime multiply, kept in 32-bit unsigned range via Math.imul.
        hash = Math.imul(hash, 0x01000193);
    }
    return (hash >>> 0).toString(36);
};
